<app-page-header title="Operators" active_item="Operadores"></app-page-header>

<form [formGroup]="filtroConta">
  <div class="loading" *ngIf="!isLoaded">
    <div class="dimmer active">
      <div class="lds-ring">
        <div></div>
      </div>
    </div>
  </div>
  <div class="row position-relative">
    <h5>Operadores</h5>

    <div class="col-md-12 col-xl-12">
      <div
        class="card sales-summary shadow"
        [ngClass]="{
          'rounded-10': !isFilterColapsed,
          'rounded-10-top': isFilterColapsed,
        }"
      >
        <div class="card-header">
          <div class="card-title mb-0">Filtros</div>
          <div class="card-options">
            <a
              href="javascript:void(0)"
              class="card-options-collapse"
              data-bs-toggle="card-collapse"
              (click)="filterColapse()"
              [attr.aria-expanded]="!isFilterColapsed"
            >
              <i
                class="fe fe-chevron-{{ !isFilterColapsed ? 'up' : 'down' }}"
              ></i>
            </a>
          </div>
        </div>

        <div
          class="card-body filter-extrato"
          [(ngbCollapse)]="isFilterColapsed"
        >
          <div class="row">
            <div class="col-xl-4 col-lg-2 col-sm-2">
              <div class="form-group">
                <label for="txtCnpj" class="form-label">Buscar por CNPJ</label>
                <div class="input-icon-container">
                  <input
                    class="form-control pe-5"
                    type="text"
                    id="txtCnpj"
                    formControlName="account"
                    mask="CPF_CNPJ"
                  />
                  <i
                    class="fe fe-clipboard input-icon cursor-pointer btn-color"
                    placement="top"
                    ngbTooltip="Colar"
                    (click)="pasteDocument()"
                  ></i>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-2 col-sm-2">
              <div class="form-group">
                <label class="form-label d-block" style="visibility: hidden">
                  Buscar
                </label>
                <button
                  type="button"
                  class="our-button btn btn-pill btn-primary"
                  (click)="buscar()"
                >
                  <i class="fe fe-search me-2"></i>Buscar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card sales-summary rounded-10 shadow">
        <div class="card-header">
          <div class="card-title mb-0">Operadores</div>

          <div class="card-options">
            <button
              type="button"
              class="btn btn-pill btn-primary float-end"
              (click)="newAccount()"
            >
              <i class="fe fe-plus me-2"></i>Nova conta
            </button>
          </div>
        </div>

        <div class="card-body button-table">
          <app-table-operators
            (operatorsLoaded)="onOperatorsLoaded()"
          ></app-table-operators>
        </div>
      </div>
    </div>
  </div>
</form>
